import { submissionQueries } from '@queries/fetchSubmissions';
import { useQuery } from '@tanstack/react-query';

export function useParentSubmission(parentSubmissionId?: string, enabled = true) {
  const { data: submission, isLoading } = useQuery({
    ...submissionQueries.forEndorsementParent(parentSubmissionId!),
    enabled: enabled && !!parentSubmissionId,
  });

  return {
    submission,
    isLoading,
  };
}
